import { useState } from 'react';

import { AddMerchantApplication, ApplicationStatus, User } from '@prisma/client';

import { PillarHeader } from 'src/components';
import HistoryTable from 'src/components/HistoryTable';
import Loader from 'src/components/Loader/Loader';
import ManageSignature from 'src/components/ServiceOrderSignature/ManageSignature';
import SignatureStatus from 'src/components/ServiceOrderSignature/SignatureStatus';
import AuthorServiceDetails from 'src/pages/MerchantApplicationPage/components/AuthorServiceDetails';
interface ServiceOrderManagementDashboardProps {
    serviceApplication: AddMerchantApplication & {
        author: User;
    };
    merchant: {
        merchantName: string;
        mid: string;
        signer: {
            firstName: string;
            lastName: string;
            email: string;
        };
    };
    fetchingApplication: boolean;
    completing: boolean;
    auditLog: {
        id: number;
        details: string;
        createdAt: string;
        userId: number;
        user: {
            id: number;
            firstName: string;
            lastName: string;
        };
    }[];
    serviceApplicationStatus?: ApplicationStatus;
    serviceApplicationID?: number;
    isAgreementSigned?: boolean;
    onApplicationStatusUpdate: (status: ApplicationStatus) => void;
    handleCompleteOrder: (status: ApplicationStatus) => void;
    processingRequestBuild: boolean;
    handleProcessServiceBuild: ({ mid, terminalId }: { mid: string; terminalId: string }) => void;
    onResendAgreement: () => void;
    resendingLoading: boolean;
    isResendDisabled: boolean;
    handleRefresh: () => void;
    isRefreshing: boolean;
    handleContinueClick?: () => void;
    agreementPreviewUrl?: string;
    onCaptureOnScreen: () => void;
}

const ServiceOrderManagementDashboard = ({
    serviceApplication,
    merchant,
    fetchingApplication,
    completing,
    auditLog,
    serviceApplicationStatus,
    serviceApplicationID,
    isAgreementSigned,
    onApplicationStatusUpdate,
    handleCompleteOrder,
    processingRequestBuild,
    handleProcessServiceBuild,
    onResendAgreement,
    resendingLoading,
    isResendDisabled,
    handleRefresh,
    isRefreshing,
    handleContinueClick,
    agreementPreviewUrl,
}: ServiceOrderManagementDashboardProps) => {
    const { merchantName, signer, mid } = merchant;
    const [terminalId, setTerminalId] = useState('');

    return (
        <>
            {fetchingApplication || completing ? <Loader /> : null}
            <PillarHeader
                heading={merchantName}
                subheading={`Service Order ID ${serviceApplicationID}`}
                sx={{
                    backgroundImage: 'url(/assets/images/backgrounds/Table.jpg)',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}
            />
            <AuthorServiceDetails application={serviceApplication} />
            <SignatureStatus
                label="Agreement Status"
                status={serviceApplicationStatus}
                onApplicationStatusUpdate={onApplicationStatusUpdate}
                handleCompleteOrder={handleCompleteOrder}
                processingRequestBuild={processingRequestBuild}
                handleProcessServiceBuild={handleProcessServiceBuild}
                terminalId={terminalId}
                mid={mid}
                handleContinueClick={handleContinueClick}
                agreementPreviewUrl={agreementPreviewUrl}
                isRefreshing={isRefreshing || fetchingApplication || completing}
                serviceApplication={serviceApplication}
            />
            <ManageSignature
                signer={signer}
                isSigned={isAgreementSigned}
                mid={mid}
                serviceApplicationStatus={serviceApplicationStatus}
                setTerminalId={setTerminalId}
                onResendAgreement={onResendAgreement}
                resendingLoading={resendingLoading}
                isResendDisabled={isResendDisabled}
                handleRefresh={handleRefresh}
                isRefreshing={isRefreshing}
            />
            <HistoryTable historyLog={auditLog ?? []} />
        </>
    );
};

export default ServiceOrderManagementDashboard;
